import { z } from 'zod';

export enum ChargerConnectorType {
    CCS1 = 'ccs1',
    CCS2 = 'ccs2',
    CHEDEMO = 'chademo',
    TESLA = 'tesla',
    TYPE1 = 'type1',
    TYPE2 = 'type2',
    NACS = 'nacs',
}

const options: { value: ChargerConnectorType; label: string }[] = [
    { value: ChargerConnectorType.CCS1, label: 'CCS1' },
    { value: ChargerConnectorType.CCS2, label: 'CCS2' },
    { value: ChargerConnectorType.CHEDEMO, label: 'CHAdeMO' },
    { value: ChargerConnectorType.TESLA, label: 'Tesla' },
    { value: ChargerConnectorType.TYPE1, label: 'Type 1' },
    { value: ChargerConnectorType.TYPE2, label: 'Type 2' },
    { value: ChargerConnectorType.NACS, label: 'NACS' },
];

const ChargerConnector = {
    validator: z.nativeEnum(ChargerConnectorType),
    options,
};

export { ChargerConnector };
